module.exports = __webpack_public_path__ + "media/10 stilt walking.6a4247ae.mp3";